/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { useEffect, useMemo } from 'react';
import { useLocation } from 'react-router';

import {
    getPreviousLocation,
    getSpaReferrer,
    updateSpaReferrer,
} from '../routing/spaReferrer';

export const SpaReferrerTracker = () => {
    const location = useLocation();
    const {
        pathname,
        search,
        hash,
    } = location;

    useEffect(() => {
        updateSpaReferrer(location);
    }, [hash, location, pathname, search]);

    return null;
};

export const usePreviousLocation = () => {
    const {
        pathname,
        search,
        hash,
    } = useLocation();

    return useMemo(() => getPreviousLocation(), [hash, pathname, search]);
};

export const useSpaReferrer = () => {
    const {
        pathname,
        search,
        hash,
    } = useLocation();

    return useMemo(() => getSpaReferrer(), [hash, pathname, search]);
};

export default usePreviousLocation;
